export default {
      id: "eye-stroke-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "sprite.svg#eye-stroke",
      toString: function () {
        return this.url;
      }
    }